import { Space as MantineSpace, SpaceProps } from "@mantine/core";

export const Space = (props: SpaceProps) => {
  return <MantineSpace {...props} />;
};
